import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { DeleteCompletedEvaluationUseCaseInterface } from 'domain/usecases';

export class RemoteDeleteCompletedEvaluation
  implements DeleteCompletedEvaluationUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: DeleteCompletedEvaluationUseCaseInterface.Params,
  ): Promise<DeleteCompletedEvaluationUseCaseInterface.Result> {
    const { surveyId } = params;

    const httpResponse = await this.httpClient.request({
      url: `${this.url}/${surveyId}`,
      method: 'delete',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
